export const NAME_COLUMN_KEY = 'name';
export const PRIORITIES_COLUMN_KEY = 'priorities';
export const PROJECTS_COLUMN_KEY = 'projects';
export const ACTIONS_COLUMN_KEY = 'actions';
export const TABLE_DEFAULT_PAGE = 1;
export const TABLE_ROWS_PER_PAGE_LIMIT = 5;

export const PROJECT_PICKER_ROWS_PER_PAGE = 10;
export const PROJECT_PICKER_PENDING_CHANGES_LIMIT = 100;

export const PRIORITY_SCHEME_NAME_FIELD = 'name';
export const PRIORITY_SCHEME_DESCRIPTION_FIELD = 'description';
export const PRIORITY_SCHEME_PRIORITIES_FIELD = 'prioritiesId';
export const PRIORITY_SCHEME_PROJECTS_FIELD = 'projectsId';
export const PRIORITY_SCHEME_MAPPINGS_FIELD = 'mappings';

export const PRIORITY_SCHEME_MODAL_DETAILS_TAB_INDEX = 0;
export const PRIORITY_SCHEME_MODAL_PROJECTS_TAB_INDEX = 1;

/**
 * Priority Scheme form is in initialising state while data is fetched for priorities and
 * projects, name and description fields will be disabled
 */
export const INIT = 'INIT';
/**
 * Priority scheme form is saving when, requests are made to either create or edit a
 * scheme. All fields will be disabled.
 */
export const SAVING = 'SAVING';
/**
 * Priority scheme form is in the failure state if there has been a failure, during
 * the initialisation process ONLY. i.e. error fetching data.
 */
export const FAILURE = 'FAILURE';
/**
 * Priority scheme form is in default state, if initialisation process has been successful
 * and users are now interacting with the form. Validation errors will be handled in this
 * state as well.
 */
export const DEFAULT = 'DEFAULT';

export const MAX_DESCRIPTION_LENGTH = 4000;
export const MAX_NAME_LENGTH = 255;

/**
 * In the future we might decide to let users sort the projects list dynamically - for now it's always one column.
 */
export const ORDER_PROJECTS_BY = NAME_COLUMN_KEY;

// https://hello.atlassian.net/wiki/spaces/MOCA/pages/2750863794/P+3+Limits
export const PRIORITY_SCHEMES_HARD_LIMIT = 300;
